// Helpers for the `chats` list of a ticket.
// Each message: { sentBy: "user" | "admin", message, isRead, timestamp }

// `chats` can arrive as an array or (on some databases) as a JSON string.
export const parseChats = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_e) {
      return [];
    }
  }
  return [];
};

// True when the other side has sent a message that this side has not read.
// User side: hasUnreadFrom(chats, "admin")
export const hasUnreadFrom = (chats, sender) =>
  parseChats(chats).some((c) => c.sentBy === sender && !c.isRead);

// Marks only the messages sent by `sender` as read (used after the chat was
// opened and the backend saved the same change).
export const markReadFrom = (chats, sender) =>
  parseChats(chats).map((c) =>
    c.sentBy === sender && !c.isRead ? { ...c, isRead: true } : c,
  );
